<script>
import forminput from "../formcomponet/forminput.vue";
import formcombobox from "../formcomponet/formcombobox.vue";
import appConfig from "@/app.config";
import Loader from "@/components/widgets/loader";
import apibtoast from "@/helpers/apibtoast";
import apigeneric from "@/helpers/apigeneric";
import mznmezunlar from "@/models/mznmezunlar";
import formdate from "../formcomponet/formdate.vue";
import Banner from "../components/banner";

export default {
  mixins: [apibtoast, apigeneric, mznmezunlar, appConfig],
  page: {
    title: "Web Siteleri",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Loader,
    forminput,
    formcombobox,
    formdate,
    Banner
  },
  data() {
    return {
      imagelist: [],
      visible: false,
      singleImage: false,
      visibleCaption: false,
      index: 0, // default: 0
      imgs: [],
      SaglikEngeliVar: false,
      FormData: {},
      AlanIsIlgiliMiKod: false,
    };
  },
  watch: {
    FormData() {
      
    },
  },
  methods: {
    Get() {
        let Page = {
        PageNumber: "1",
        PageSize: "10",
        PageDataSize: "1",
      };
        this.ActionsFilterGet({
        Service: this.$config.API_URL_2 + "mznmezunlar",
        Page: Page,
        Filter: "&Userid=" + this.TokenUserId,
      }).then((res) => {
        if (res.Data.length > 0) {
          this.FormData = res.Data[0];
          if(this.FormData.Calismadurumu != null && this.FormData.AlanIsIlgiliMi != null 
          && this.FormData.Eposta != null && this.FormData.Telefon != null 
          && this.FormData.Evadresi != null && this.FormData.Yesilisalani != null){
            if(this.FormData.AlanIsIlgiliMi == true ){
              if(this.FormData.Calismadurumu != null && this.FormData.AlanIsIlgiliMi != null 
              && this.FormData.Eposta != null && this.FormData.Telefon != null 
              && this.FormData.Evadresi != null || this.FormData.IlkIseGirisTarihi != null)
              {
                //window.location.href = "/";
              }
            }
            else{
              //window.location.href = "/";
            }

          }

      this.SaglikEngeliAciklama(this.FormData.Saglikengeli)
      this.FormData.Egitimbilgileri = JSON.parse(this.FormData.Egitimbilgileri);
      this.FormData.Isstajbilgileri = JSON.parse(this.FormData.Isstajbilgileri);
      this.FormData.Kursbilgileri = JSON.parse(this.FormData.Kursbilgileri);
      this.FormData.Sertifikabilgileri = JSON.parse(
        this.FormData.Sertifikabilgileri
      );
      this.FormData.Sinavbilgisi = JSON.parse(this.FormData.Sinavbilgisi);
      this.FormData.Yabancidilbilgisi = JSON.parse(
        this.FormData.Yabancidilbilgisi
      );
      this.FormData.Bilgisayarbilgisi = JSON.parse(
        this.FormData.Bilgisayarbilgisi
      );
      this.FormData.Yayinbilgilerim = JSON.parse(this.FormData.Yayinbilgilerim);
      this.FormData.Odulbilgileri = JSON.parse(this.FormData.Odulbilgileri);
      this.FormData.Projebilgileri = JSON.parse(this.FormData.Projebilgileri);
      this.FormData.Kulturelfaaliyetbilgileri = JSON.parse(
        this.FormData.Kulturelfaaliyetbilgileri
      );
      this.FormData.Dernekuyelikleri = JSON.parse(
        this.FormData.Dernekuyelikleri
      );
      this.FormData.Yetkinlikler = JSON.parse(this.FormData.Yetkinlikler);
      this.FormData.Referanslar = JSON.parse(this.FormData.Referanslar);
      this.FormData.Gizlilik = JSON.parse(this.FormData.Gizlilik);
    }
      });
    },
    AlanISIlgiliMiValue(Id){
      this.ActionsSingleGet({
        Service: "okeyvalues",
        Id: Id,
      }).then((res) => {
        if(res.Data.Tip == 2 && res.Data.Kod == 1){
          this.AlanIsIlgiliMiKod = true;
        }else{
          this.AlanIsIlgiliMiKod = false;
        }
      });
    },

    onSubmit() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        var FormData = this.FormData;


        FormData.Egitimbilgileri = JSON.stringify(FormData.Egitimbilgileri);
        FormData.Isstajbilgileri = JSON.stringify(FormData.Isstajbilgileri);
        FormData.Kursbilgileri = JSON.stringify(FormData.Kursbilgileri);
        FormData.Sertifikabilgileri = JSON.stringify(
          FormData.Sertifikabilgileri
        );
        FormData.Sinavbilgisi = JSON.stringify(FormData.Sinavbilgisi);
        FormData.Yabancidilbilgisi = JSON.stringify(
          FormData.Yabancidilbilgisi
        );
        FormData.Bilgisayarbilgisi = JSON.stringify(
          FormData.Bilgisayarbilgisi
        );
        FormData.Yayinbilgilerim = JSON.stringify(FormData.Yayinbilgilerim);
        FormData.Odulbilgileri = JSON.stringify(FormData.Odulbilgileri);
        FormData.Projebilgileri = JSON.stringify(FormData.Projebilgileri);
        FormData.Kulturelfaaliyetbilgileri = JSON.stringify(
          FormData.Kulturelfaaliyetbilgileri
        );
        FormData.Dernekuyelikleri = JSON.stringify(FormData.Dernekuyelikleri);
        FormData.Yetkinlikler = JSON.stringify(FormData.Yetkinlikler);
        FormData.Referanslar = JSON.stringify(FormData.Referanslar);
        FormData.Gizlilik = JSON.stringify(FormData.Gizlilik);

          if (FormData.Calismadurumu != null && FormData.AlanIsIlgiliMi != null 
            && FormData.Eposta != null && FormData.Telefon != null 
            && FormData.Evadresi != null && FormData.Yesilisalani != null
            && FormData.KisiselEposta != null
          )
          {

                this.Update(this.$config.API_URL_2 + "mznmezunlar", FormData).then(
                  (res) => {
                    if (res) {
                      this.$emit("TableUpdate");
                      this.$bvModal.hide("mznmezunlar");
                      window.location.href = "/";
                    }
                  }
                );
          } else{
            this.$toast.success("Kaydetmek için tüm alanları doldurmalısınız!");

          }
      }
    },
    created(){

    }


  }
};
</script>

<template>
  <Loader>
    <Banner />
    <div class="row">
      <div class="col-md-12">
        <div class="profile-detail">
          <div class="row d-flex align-items-center justify-content-center">
            <div class="col-md-8">

              <div class="profile-form">
                <Form @submit.prevent="onSubmit">
                  <b-tabs justified nav-class="nav-tabs-custom" content-class="p-3 text-muted">
                    <b-tab active>
                      <template v-slot:title>
                        <span class="d-inline-block d-sm-none">
                          <i class="fas fa-home"></i>
                        </span>
                        <span class="d-none d-sm-inline-block">
                          {{
                          $t("mznmezunlar.AddEdit.ZorunluBilgiler.Title")
                          }}</span>
                      </template>
                      <div class="card mt-3">
                        <div class="card-body">
                          <div class="row">
                            <div class="col-md-6">
                              <h4 class="card-title mb-4">
                                {{
                                $t(
                                "mznmezunlar.AddEdit.ZorunluBilgiler.Title"
                                )
                                }}
                              </h4>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-md-6">
                              <formcombobox :FormDataType="FormDataType.Calismadurumu" :Value="FormData.Calismadurumu"
                                :v="$v.FormData.Calismadurumu" @input="FormData.Calismadurumu = $event" />
                            </div>
                            <div class="col-md-6">
                              <formcombobox :FormDataType="FormDataType.AlanIsIlgiliMi" :Value="FormData.AlanIsIlgiliMi"
                                :v="$v.FormData.AlanIsIlgiliMi" @input="FormData.AlanIsIlgiliMi = $event, AlanISIlgiliMiValue(FormData.AlanIsIlgiliMi)" />
                            </div>
                            <div class="col-md-6" v-if="AlanIsIlgiliMiKod == true" >
                              <formdate :FormDataType="FormDataType.IlkIseGirisTarihi" :Value="FormData.IlkIseGirisTarihi"
                                :v="$v.FormData.IlkIseGirisTarihi" @input="FormData.IlkIseGirisTarihi = $event" />
                            </div>
                            <div class="col-md-6">
                              <forminput :FormDataType="FormDataType.Eposta" :Value="FormData.Eposta"
                                :v="$v.FormData.Eposta" @input="FormData.Eposta = $event" />
                            </div>
                            <div class="col-md-6">
                              <forminput :FormDataType="FormDataType.KisiselEposta" :Value="FormData.KisiselEposta"
                                :v="$v.FormData.KisiselEposta" @input="FormData.KisiselEposta = $event" />
                            </div>
                            <div class="col-md-6">
                              <forminput :FormDataType="FormDataType.Telefon" :Value="FormData.Telefon"
                                :v="$v.FormData.Telefon" @input="FormData.Telefon = $event" />
                            </div>
                            <div class="col-md-6">
                              <forminput :FormDataType="FormDataType.Evadresi" :Value="FormData.Evadresi"
                                :v="$v.FormData.Evadresi" @input="FormData.Evadresi = $event" />
                            </div>
                            <div class="col-md-6">
                              <div class="d-flex align-items-center">
                               <div class="flex-grow-1">
                              <formcombobox :FormDataType="FormDataType.Yesilisalani" :Value="FormData.Yesilisalani"
                                :v="$v.FormData.Yesilisalani" @input="FormData.Yesilisalani = $event" />
                                </div>
                                      <span class="info-tooltip">
                                      <i class="fas fa-info-circle ms-2 cursor-pointer"></i>
                                        <span class="tooltip-text">
                                       Birleşmiş Milletler Çevre Programı (UNEP) “yeşil iş”i, çevresel kalitenin korunmasına veya eski haline getirilmesinde önemli ölçüde katkıda bulunan tarım, imalat, araştırma ve geliştirme, idari ve hizmet faaliyetlerinde çalışmak olarak tanımlamaktadır. 
                                       Örnek: Atık Yönetimi Mühendisi, Yenilenebilir Enerji Uzmanı, Sürdürülebilir Tarım Danışmanı, Organik Ürün Uzmanı, Deniz Koruma Müdürü, Deniz Biyoloğu, Yenilenebilir Enerji Mühendisi, Enerji Verimliliği Uzmanı vb.
                                      </span>
                                    </span>
                                  </div>
                            </div>

                    
                          </div>
                        </div>
                      </div>
                    </b-tab>
                
                  </b-tabs>

                  <button class="btn btn-primary mb-5" type="submit">
                    {{ $t("mznmezunlar.AddEdit.Button") }}
                  </button>
                </Form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Loader>
</template>
<style scoped>
.info-tooltip {
  position: relative;
  display: inline-block;
  cursor: pointer;
}

.tooltip-text {
  visibility: hidden;
  opacity: 0;
  width: max-content;
  max-width: 250px;
  background-color: #333;
  color: #fff;
  text-align: left;
  padding: 8px 10px;
  border-radius: 6px;
  position: absolute;
  bottom: 130%;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1000;
  transition: opacity 0.2s ease;
  font-size: 13px;
}

.tooltip-text::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  border-width: 6px;
  border-style: solid;
  border-color: #333 transparent transparent transparent;
}

.info-tooltip:hover .tooltip-text {
  visibility: visible;
  opacity: 1;
}
</style>
